module.exports = __webpack_public_path__ + "static/media/aftertop1.51d2daf2.png";